import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { IDENTITY_PROVIDERS } from '@24i/nxg-core-utils/src/constants';
import { useUserData } from '@24i/nxg-sdk-smartott-shared/src/context/UserData';
import { log } from '@24i/nxg-core-utils/src/logger';
import QueryPersistCacheInstance from '@24i/nxg-sdk-smartott-shared/src/context/Query/queryPersistCacheInstance';
import { providerLogout, removeUserDataFromStorage, sendLogoutAnalytics } from '../../utils/auth';
import { useAppStart } from '../../context/AppStartContext';
import useUserSession from '../useUserSession';
import { useLogoutNavigation } from '../useLogoutNavigation';

export const useAuth = () => {
    const useSessionContext = useUserSession();
    const queryClient = useQueryClient();
    const userDataClient = useUserData();
    const identityProvider = useFeature('identityProvider');
    const { onLogout } = useAppStart();
    const { navigateAfterLogout } = useLogoutNavigation();
    const provider = identityProvider?.enabled
        ? (identityProvider?.provider as IDENTITY_PROVIDERS)
        : undefined;

    const logout = useCallback(async () => {
        try {
            await queryClient.cancelQueries();
            await userDataClient.logout(provider);
            await providerLogout(provider);
            onLogout();

            sendLogoutAnalytics();

            await removeUserDataFromStorage();

            await useSessionContext.signOutUser();

            await QueryPersistCacheInstance.getInstance()?.getPersistor()?.removeClient();

            await navigateAfterLogout(provider);
            queryClient.clear();
        } catch (e) {
            log(e);
        }
    }, [provider]);

    return { logout };
};
